export default "__VITE_ASSET__BYiGaM3j__"